import { clsx } from 'clsx';

import styles from './Filter.css';

interface IFilterProps {
  className?: string;
  dataTestId?: string;
}

export const Filter: React.FC<React.PropsWithChildren<IFilterProps>> = ({ className, children, dataTestId }) => {
  return (
    <div className={clsx(styles['container'], className)} data-testid={dataTestId}>
      {children}
    </div>
  );
};
